import Validator from './validator'
import AuthUser from './authUser'

export default (Vue) => {
  Vue.mixin(Validator)
  Vue.mixin(AuthUser)
}